<!--
 * @Author: your name
 * @Date: 2021-06-08 08:39:32
 * @LastEditTime: 2022-02-14 17:18:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sga-fd-sgaH5NEW\xyusermodule\src\views\myCard\cardListVice.vue
-->
<template>
  <div class="card-list-page">
    <div
      :style="{
        backgroundImage: 'url(' + item.bg + ')',
        backgroundSize: 'cover',
      }"
      class="card-item"
      v-for="(item, index) in cardList"
      :key="index"
      @click="toNextPage(item)"
    >
      <img class="img-ico" :src="item.ico" />
      <div class="item-title">{{ item.certificateType }}</div>
    </div>
  </div>
</template>

<script>
import checkAJB from "@/utils/checkAlipayJSBridge.js";
import { request } from "@/utils/request.js";
export default {
  data() {
    return {
      sessionId: "",
      imgList: [
        {
          ico: require("../../assets/img/card/ico1.png"),
          bg: require("../../assets/img/card/bg1.png"),
        },
        {
          ico: require("../../assets/img/card/ico2.png"),
          bg: require("../../assets/img/card/bg2.png"),
        },
        {
          ico: require("../../assets/img/card/ico3.png"),
          bg: require("../../assets/img/card/bg3.png"),
        },
        {
          ico: require("../../assets/img/card/ico4.png"),
          bg: require("../../assets/img/card/bg4.png"),
        },
        {
          ico: require("../../assets/img/card/ico5.png"),
          bg: require("../../assets/img/card/bg5.png"),
        },
      ],
      cardList: [],
    };
  },
  created() {
   
    this.getCardList();
  },
  methods: {
    async getCardList() {
      let userInfo = await checkAJB.getUserInfo();
      this.sessionId = userInfo.sgasession;
      this.request({
        url: "/sga/user/elcCardLegalRetrieval",
        type: "post",
        header: {
          sessionId: this.sessionId,
        },
        params: {},
      }).then((res) => {
        console.log("res-----");
        console.log(res);
        if (res.respCode == "00000000") {
          this.cardList = res.respData.dataList;
          this.cardList.forEach((item, index) => {
            if (index < 5) {
              item.bg = this.imgList[index].bg;
              item.ico = this.imgList[index].ico;
            } else {
              let num = index % 5;
              item.bg = this.imgList[num].bg;
              item.ico = this.imgList[num].ico;
            }
          });
        } else {
          this.$toast(res.respMsg);
        }
      });
    },
    toNextPage(item) {
      let url =
        "/sga/sgah5/usermodule/index.html#/cardView?certificateID=" +
        item.certificateID +
        "&bg=" +
        item.bg;
      checkAJB.openNewWindow({
        url: url,
      });
    },
  },
};
</script>

<style scoped lang="less">
.card-list-page {
  padding: 10px 0px;
  .card-item {
    width: 100%;
    height: 125px;
    font-size: 18px;
    color: #ffffff;
    display: flex;
    align-items: center;
    .img-ico {
      width: 40px;
      height: 40px;
      margin: 0px 15px 0px 25px;
    }
    .item-title {
      width: calc(100% - 100px);
      line-height: 35px;
    }
  }
}
</style>
